import { render, staticRenderFns } from "./PCustomerSelectItem.vue?vue&type=template&id=a970a9f2"
import script from "./PCustomerSelectItem.vue?vue&type=script&lang=js"
export * from "./PCustomerSelectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports